export default __webpack_public_path__ + "static/media/section-heading-priority-ticket.c2c04ce4.svg";